import { useSelector, useDispatch } from "react-redux";
import i18n from "../i18n/config";
import { setLanguage } from "../store/slices/i18nSlice";

export default function useI18n() {
  const dispatch = useDispatch();
  const language = useSelector((state) => state.i18n.language);

  const changeLanguage = (lng) => {
    dispatch(setLanguage(lng));
  };

  return {
    t: i18n.t.bind(i18n),
    lang: language,
    changeLanguage,
  };
}
